export function dateInputFormatter(date) {
    if (!date)
        return;
    if (typeof date == 'string') {
        date = new Date(date);
    }
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return `${date.getFullYear()}-${month}-${day}`;
}
export function dateTimeInputFormatter(date) {
    if (!date)
        return;
    if (typeof date == 'string') {
        date = new Date(date);
    }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    if (hours < 10) {
        hours = '0' + hours;
    }
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    return `${hours}:${minutes}`;
}
export function dateLocalInputFormatter(date) {
    if (!date)
        return;
    if (typeof date == 'string') {
        date = new Date(date);
    }
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return `${day}/${month}/${date.getFullYear()}`;
}
export function verfEmail(email) {
    const regex = /[\w\.-]+@[\w\.-]+\.\w{2,4}/;
    if (!regex.test(email)) {
        return false;
    }
    else {
        return true;
    }
}
